// Credit: DSchau
// https://github.com/gatsbyjs/gatsby/issues/10174
export default function convertTokens(content, data) {
  if (!content || !data) {
    return null
  }
  return content.replace(/{{(.*?)}}/g, (match, key) => {
    let value
    // Check if token is object
    if (key.includes(".")) {
      let arr = key.split(".")
      // If object keys match metadata, return value of object
      if (
        typeof data[arr[0]] !== "undefined" ||
        typeof data[arr[1]] !== "undefined"
      ) {
        value = data[arr[0]][arr[1]]
        if (typeof value !== "undefined") {
          if (value) return value
        }
        return match
      }
    } else {
      value = data[key]
      if (typeof value !== "undefined") {
        return value
      }
      return match // guards against some unintentional prefix
    }
  })
}
